module.exports = sana["lib"]["react/jsx-runtime"];